import Close from '@mui/icons-material/Close'
import {
  Box,
  Dialog,
  DialogActions,
  dialogActionsClasses,
  dialogClasses,
  DialogContent,
  dialogContentClasses,
  DialogTitle,
  dialogTitleClasses,
  IconButton,
  paperClasses,
  SxProps,
  Typography,
} from '@mui/material'
import { grey } from '@mui/material/colors'

import { ModalWrapProps } from 'common/interfaces'
import StyledWrap from 'components/StyledWrap'
import { concatToSXProp } from 'utils/style'

const modalStyles: Record<string, SxProps> = {
  wrap: {
    [`& .${dialogClasses.container}`]: {
      alignItems: 'flex-start',
    },
    [`& .${paperClasses.root}`]: {
      width: {
        xs: '90vw',
        md: '528px',
      },
      maxHeight: {
        xs: 'unset',
        md: 'calc(100% - 65px)',
      },
      margin: 0,
      marginTop: {
        xs: '50%',
        md: '65px',
      },
      borderRadius: '8px',
      boxShadow: 'none',
    },
    [`& .${dialogTitleClasses.root}`]: {
      paddingTop: '24px',
      paddingBottom: {
        xs: '24px',
        md: '16px',
      },
      textTransform: 'unset',
    },
    [`& .${dialogContentClasses.root}`]: {
      flex: 'unset',
      padding: {
        xs: '24px 24px 16px',
        md: '24px',
      },
    },
    [`& .${dialogActionsClasses.root}`]: {
      flexDirection: {
        xs: 'column-reverse',
        md: 'row',
      },
      justifyContent: 'flex-end',
      padding: '0 24px 24px',
      '& > :not(:first-of-type)': {
        padding: '8px 24px',
        marginBottom: {
          xs: '16px',
          md: 0,
        },
        marginLeft: {
          xs: 0,
          md: '16px',
        },
      },
    },
  },
}

export default function ModalWrap({
  style,
  open,
  title,
  children,
  actions,
  onClose,
}: ModalWrapProps): JSX.Element {
  const { wrap } = modalStyles

  return (
    <StyledWrap elementName="ModalWrap">
      <Dialog
        disablePortal
        className="modal"
        open={open}
        onClose={onClose}
        sx={concatToSXProp(wrap, style ?? {})}
      >
        <DialogTitle className="modal-header" component="div">
          <Box
            className="modal-header-inner"
            display="flex"
            alignItems="center"
            justifyContent={title !== null ? 'space-between' : 'flex-end'}
          >
            {title !== null && (
              <Typography className="modal-title" variant="h3">
                {title}
              </Typography>
            )}
            <IconButton className="modal-close" onClick={onClose} sx={{ padding: 0 }}>
              <Close sx={{ color: grey[600] }} />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent className="modal-content">{children}</DialogContent>
        {actions != null && <DialogActions className="modal-actions">{actions}</DialogActions>}
      </Dialog>
    </StyledWrap>
  )
}
